<template>
  <SoPageWithRightSidePanel v-model="current.isSidePanelCollapsed">
    <SoSkeleton v-if="isLoading" type="card" />
    <template v-else>
      <SoAlert
        v-if="current.imbpAccount.isError"
        data-testid="account-error"
        type="error"
      >
        There was a error retrieving the account details
      </SoAlert>
      <SoFlow
        v-else
        :workflow-id="
          newImbpBookingFlow ? FlowType.ImbpBookingNew : FlowType.ImbpQuestions
        "
        :account-number="accountNumber"
        data-testid="imbp-booking-flow"
        title="IMBP Appointments"
        @closed="flowClosed()"
      />
    </template>
    <template #sidePanel>
      <CustomerAccountInfoPanel></CustomerAccountInfoPanel>
    </template>
    <template #sidePanelRail>
      <CustomerAccountInfoRail></CustomerAccountInfoRail>
    </template>
  </SoPageWithRightSidePanel>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoFlow from "@/flows/SoFlow.vue"
  import { FlowType } from "@/flows/useCases"
  import SoAlert from "@/components/SoAlert.vue"
  import SoPageWithRightSidePanel from "@/components/templates/SoPageWithRightSidePanel.vue"
  import SoSkeleton from "@/components/SoSkeleton.vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import CustomerAccountInfoPanel from "../overview/CustomerAccountInfoPanel.vue"
  import CustomerAccountInfoRail from "../overview/CustomerAccountInfoRail.vue"
  import { RouteNames } from "@/types/router"
  import { useSnackbarStore } from "@/stores/snackbar"

  export default defineComponent({
    components: {
      SoPageWithRightSidePanel,
      CustomerAccountInfoPanel,
      CustomerAccountInfoRail,
      SoFlow,
      SoAlert,
      SoSkeleton,
    },
    data() {
      return {
        FlowType,
        accountNumber: useCurrentAccountStore().accountNumber,
        current: useCurrentAccountStore(),
        showInterestModal: false,
        snackbar: useSnackbarStore(),
        newImbpBookingFlow: true,
      }
    },
    computed: {
      isLoading() {
        return this.hasNotFetched && this.hasNoError
      },
      hasNotFetched() {
        return (
          !this.current.imbpAccount.isFetched ||
          !this.current.imbpBookings.isFetched
        )
      },
      hasNoError() {
        return !this.current.imbpAccount.isError
      },
    },
    methods: {
      flowClosed() {
        this.$router.push({ name: RouteNames.CustomerMeterpoints })
      },
      redirect() {
        this.$router.push({ name: RouteNames.CustomerMeterpoints })
        this.snackbar.addSuccess(
          "Availability saved. The customer will receive an email when matching appointments become available.",
        )
      },
    },
  })
</script>
